import { generateOzmoHomeUrl } from "@expert/solve-tools";
import { LaunchGuideIcon, LaunchOzmoIcon, NotepadIcon, ResetAssistIcon } from "../../assets";
import type { GuideCommand } from "../../shared-types";
import { useTimelineStore } from "../../state";

export type ToolboxAction = "OpenNotepad" | "ResetAssist" | "LaunchOzmo" | "LaunchGuide";
export interface MenuItemUI {
    label: string;
    icon: React.JSX.Element;
    disabled: boolean;
    actionId: ToolboxAction;
    quickActionLabel?: string;
    confirmationLabel?: string;
    tooltip?: string;
    additionalProps?: Record<string, unknown>;
}

export interface MenuItemProps {
    id: string;
    item: MenuItemUI;
    focusedMenuItem: string;
    onClick: (item: MenuItemUI) => void;
}

export interface ToolboxContext {
    guide?: GuideCommand;
    isOzmoEnabled?: boolean;
    isOzmoIFrameEnabled?: boolean;
}

// [EWS-1376](https://solutonashville.atlassian.net/browse/EWS-1376)
const ozmoAction = {
    actionId: "LaunchOzmo",
    disabled: false,
    icon: <LaunchOzmoIcon />,
    label: "Launch Ozmo",
    quickActionLabel: "/o",
};

export const toolboxUIMapping = ({ guide, isOzmoEnabled = true, isOzmoIFrameEnabled }: ToolboxContext) => {
    const { currentSessionId, getTimelineState } = useTimelineStore.getState();
    const { callSid, partner } = getTimelineState(currentSessionId);

    return [
        {
            actionId: "OpenNotepad",
            disabled: false,
            icon: <NotepadIcon />,
            label: "Notepad",
            quickActionLabel: "/n",
        },
        {
            actionId: "ResetAssist",
            confirmationLabel: "This will clear Assist history for this conversation. Are you sure you want to reset?",
            disabled: false,
            icon: <ResetAssistIcon />,
            label: "Reset Assist",
            quickActionLabel: "/r",
            tooltip: "This’ll clear the Assist history",
        },
        isOzmoEnabled
            ? isOzmoIFrameEnabled
                ? { ...ozmoAction }
                : {
                      ...ozmoAction,
                      additionalProps: {
                          component: "a",
                          href: generateOzmoHomeUrl(currentSessionId, partner, callSid),
                          target: "_blank",
                      },
                  }
            : null,
        guide && {
            actionId: "LaunchGuide",
            icon: <LaunchGuideIcon />,
            label: "Launch guided flow",
            ...guide,
        },
    ].filter((x) => !!x) as MenuItemUI[];
};
